export default __webpack_public_path__ + "static/media/clap-icon.74051b12.svg";